var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter"},_vm._l((_vm.categories),function(category){return _c('a',{key:category.id,staticClass:"filter__element",class:{ active: category === _vm.selectedCategory},on:{"click":function($event){_vm.toggleChip(category)}}},[_vm._v("\n        "+_vm._s(category.name)+"\n    ")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cb5b5ca","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/FilterChips.vue
// module id = 951
// module chunks = 5